import { useEffect, useMemo, useState } from 'react';
import { INFO_PAGES, type InfoPageId } from '../content/infoPages';

export type AppRoute =
  | { name: 'dashboard' }
  | { name: 'coin'; symbol: string }
  | { name: 'info'; page: InfoPageId }
  | { name: 'not-found' };

const INFO_PAGE_SET = new Set<string>(INFO_PAGES);

function parseHash(hash: string): AppRoute {
  const clean = hash.replace(/^#/, '') || '/';
  const coinMatch = clean.match(/^\/coin\/([A-Za-z0-9_-]+)$/);
  if (coinMatch?.[1]) return { name: 'coin', symbol: coinMatch[1].toUpperCase() };
  if (clean === '/' || clean === '/dashboard') return { name: 'dashboard' };
  const infoMatch = clean.match(/^\/([a-z0-9-]+)$/);
  if (infoMatch?.[1] && INFO_PAGE_SET.has(infoMatch[1])) return { name: 'info', page: infoMatch[1] as InfoPageId };
  return { name: 'not-found' };
}

export function navigate(path: string): void {
  window.location.hash = path;
}

export function useHashRoute(): AppRoute {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const listener = () => setHash(window.location.hash);
    window.addEventListener('hashchange', listener);
    return () => window.removeEventListener('hashchange', listener);
  }, []);
  return useMemo(() => parseHash(hash), [hash]);
}
